var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('loading'):(_vm.noData)?[_c('v-alert',{attrs:{"value":"true","type":"error","dismissible":""}},[_vm._v("\n            No fantasy projections available for this league at this time.\n        ")])]:[_c(_vm.$route.params.league.toUpperCase(),{tag:"component"})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }